const data = [
	{
		Activities: `Initiated Students appreciation activity KOUTUK SOHLA`,
	},
	{
		Activities: `Guided many students club activities like Cyber Security Club, IoT club etc`,
	},
	{
		Activities: `Motivated and encouraged students to enroll and complete NPTEL courses`,
	},
	{
		Activities: `Motivated and encouraged students to enroll and complete COURSERA courses`,
	},
	{
		Activities: `Organized many International Sessions for the students from the company like 
		Facebook, VMware, Mathworks, Aristocrat etc`,
	},
	{
		Activities: `Organized technical activities for the students CREST-2019
		`,
	},
	{
		Activities: `Organized “IDEAZZ….2K17” a university level B.E project work competition on 26th
		September 2017.`,
	},
	{
		Activities: `Organized various Value Addition Program ( e.g java, advanced java, PHP etc.) for the 
		students`,
	},
	{
		Activities: `Arranged many Guest Sessions for the students on recent technologies by the industry 
		experts`,
	},
	{
		Activities: `Organized the national level Technical Symposium “Techtonic” as a coordinator and the 
		team members`,
	},
	{
		Activities: `Worked as a coordinator and team member of various workshop conducted for the 
		students at department level`,
	},
	{
		Activities: ` Industrial Visit coordinator for the students as a part of Industry Institute Interaction`,
	},
];

export default data;
